// src/api.ts
import axios from 'axios';

export const DEFAULT_API_URL =
  'https://stockingly-backend.vercel.app/api/';

const LOCAL_API_HOST_PATTERN =
  /^https?:\/\/(?:localhost|127(?:\.\d{1,3}){3}|\[::1\])(?::\d+)?(?:\/|$)/i;

export const resolveApiBaseUrl = (
  configuredUrl: string | undefined,
  isProduction: boolean
) => {
  const candidate = configuredUrl?.trim();

  // CRA loads .env.local for production builds as well. A build created on a
  // developer machine must never ship an API URL that points the visitor's
  // browser back to localhost.
  if (!candidate || (isProduction && LOCAL_API_HOST_PATTERN.test(candidate))) {
    return DEFAULT_API_URL;
  }

  return candidate.endsWith('/') ? candidate : `${candidate}/`;
};

const api = axios.create({
  baseURL: resolveApiBaseUrl(
    process.env.REACT_APP_API_URL,
    process.env.NODE_ENV === 'production'
  ),
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
//Vercel
//"https://stockingly-backend.vercel.app/api/"

//Local
//"http://localhost:5001/api/"
